import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';

export default class TextInput extends PureComponent {
  static defaultProps = {
    type: 'text',
  }

  static propTypes = {
    className: RPT.string,
    disabled: RPT.bool,
    id: RPT.string,
    label: RPT.string,
    name: RPT.string,
    onChange: RPT.func,
    placeholder: RPT.string,
    type: RPT.string,
    error: RPT.string,
  }

  render() {
    const {
      disabled,
      className,
      id,
      label,
      name,
      onChange,
      type,
      placeholder,
      error,
    } = this.props;

    return (
      <div className="checkbox">
        <label>
          <input
            onChange={onChange}
            type={type}
            name={name}
            id={id}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            {...this.props}
          />
          <span dangerouslySetInnerHTML={{ __html: label }} />
        </label>
        {error && <span className="form-help">
          {error}
        </span>}
      </div>
    );
  }
}
